import { useCallback } from "react";

import {
  RequestProposalCardVariant,
  UseRequestProposalCardProps,
} from "@companion-core/shared/app/Components/Requests/RequestProposalCard/requestProposalCard.model";
import { trackRecommendationPublisher } from "@companion-core/shared/app/tracking/requests";
import { useMemberData } from "@companion-core/shared/app/Hooks/member";

export const useRequestProposalCard = ({
  id,
  position,
  nbItems,
  url,
  format,
  variant = RequestProposalCardVariant.Proposal,
  vendorId,
}: UseRequestProposalCardProps) => {
  const { data: memberData } = useMemberData();

  const onProposalCardVisible = useCallback(() => {
    trackRecommendationPublisher({
      pageSlug: variant,
      url,
      contentId: id,
      positionItem: position ?? 0,
      nbItems: nbItems ?? 0,
      format,
      memberId: memberData?.id,
      vendorId: vendorId,
    });
  }, [nbItems, position, url]);

  return {
    onProposalCardVisible,
  };
};
